import { Props } from 'shared/@types';
import { TermsOfUseScreen } from 'shared/screens/terms-of-use';
import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';

export default function TermsOfUse(props: Props) {
  const { t } = useTranslation('web');

  return (
    <Page {...props} register={(seo) => seo.setTitle(t('layout.footer.terms_of_use'))}>
      <TermsOfUseScreen />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
